import React from 'react'
import { P } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import { PRODUCTS } from 'lib/products/constants'
import { RoleSection, RoleTemplate, RoleTitle, RoleUl } from '../RoleTemplate'

const ProbateSalesExecutive = (): React.JSX.Element => (
  <RoleTemplate
    roleName="Probate Sales Executive"
    roleUrl="https://dignity.kallidusrecruit.com/VacancyInformation.aspx?VId=2311"
    location="Maidenhead (Hybrid – 3 days on-site, 2 days from home)"
    salary="£30,000 base + performance-based bonus that could take full earnings to £45k"
    contractType="Full-time, Permanent"
    closingDate="31st May 2025"
    product={PRODUCTS.PROBATE}
    content={
      <>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>The Role</RoleTitle>
          <P>
            We’re looking for an ambitious Sales Executive to help us deliver an
            exceptional Probate service to our customers. Probate is a daunting
            task that we strive to make simpler, faster and more affordable than
            traditional providers. Part of how we do that is through building a
            fantastic team of people who are legally savvy, commercially minded
            and motivated by compassionately helping people through those
            difficult challenges.
          </P>
          <P>
            As a Sales Executive, you’ll be responsible for shaping and defining
            how we run and sell our Probate service. You’ll work towards
            commercial goals while focusing on the importance of delivering a
            best-in-class customer experience.
          </P>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>In this role you will:</RoleTitle>
          <RoleUl>
            <li>
              Build rapport and trust with customers, making a stressful time
              and process as easy as possible.
            </li>
            <li>
              Learn the intricacies of what happens to someone’s estate when
              they die, and diagnose the estates of your customers.
            </li>
            <li>
              Guide customers through the government requirements for probate,
              and what needs to happen and why.
            </li>
            <li>
              Explain our different types of Probate services so the customer
              can make the right decision based on their estate complexity and
              needs.
            </li>
            <li>
              Prove consistency in our weekly and quarterly sales targets,
              including conversion rates and QA (Quality Assurance) scores on
              our inbound enquiries.
            </li>
            <li>Master smooth and detailed handovers to our Legal team.</li>
            <li>
              Work cross-functionally towards our company OKRs and monthly
              revenue targets, and assist with quarterly team presentations.
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>We are looking for:</RoleTitle>
          <RoleUl>
            <li>
              Demonstrated success in a sales roles, ideally within B2C,
              service-oriented industries such as legal services, financial
              services, or customer support.
            </li>
            <li>
              Ability to quickly learn and adapt to new software and tools as
              needed.
            </li>
            <li>Achieved GCSEs A-C in English & Maths.</li>
            <li>
              An interest in legal processes and ideally have a legal education
              and/or work experience.
            </li>
            <li>
              A team player that values honesty, collaboration and delivering
              exceptional service to customers.
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What we offer:</RoleTitle>
          <RoleUl>
            <li>Annual salary of £30,000 plus performance-based bonus</li>
            <li>25 Days Holiday + Bank Holidays</li>
            <li>X2 Life Assurance</li>
            <li>Pension Scheme</li>
            <li>Hybrid flexible working (3 days in our Maidenhead office)</li>
            <li>Genuine career progression and mentorship opportunities</li>
          </RoleUl>
        </RoleSection>
      </>
    }
  />
)

export default ProbateSalesExecutive
